import config from '../../../utils/client/publicConfig'

export default function useConfig() {
  return config()
}
